import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md", testId = "site-logo" }) => {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-3xl",
  };
  return (
    <Link to="/" data-testid={testId} className={`brand-text ${sizes[size]} select-none`}>
      <span style={{ color: "#0F766E" }}>Repair</span>
      <span style={{ color: "#0891B2" }}>ro</span>
    </Link>
  );
};

export default Logo;
